import type { InjectOptions, Injector, ProviderToken } from '@angular/core';

let rootInjector: Injector | undefined;

/**
 * Use to get **root** injector outside of DI context
 * @throws if getting of root injector fails or getting token fails it throws
 */
function injectRoot<T>(token: ProviderToken<T>, options?: InjectOptions): T {
  if (!rootInjector) {
    throw new Error('No root injector');
  }

  return rootInjector.get(token, undefined, options);
}

/**
 * Function is used to set root injector to be able to access injector through `injectRoot`.
 * It can be set only once.
 *
 * **Use `injectRoot` function**
 */
function setRootInjector(injector: Injector): void {
  if (rootInjector) {
    throw new Error('Root injector is already set. You can set it only once.');
  }

  rootInjector = injector;
}

export { injectRoot, setRootInjector };
